import { AlertType, AnbModal, AnbSnackBarService, SnackBarAlert } from '@anb/ng-ui';
import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { LabelClient } from '@core/api/proxy';
import { TranslateService } from '@ngx-translate/core';
import { ExceptionDialogComponent } from '@shared/components/exception-dialog/exception-dialog.component';
import { catchError, fromEvent, map, Observable, of, Subject, switchMap } from 'rxjs';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css'],
})
export class UploadComponent implements OnInit {
  @ViewChild('fileInput') fileInput: ElementRef;
  private fileSelectedSubject = new Subject<File>();
  private snackbarService = inject(AnbSnackBarService);
  private translateService = inject(TranslateService);
  private anbModal = inject(AnbModal);

  constructor(private client: LabelClient) {}
  ngOnInit(): void {
    this.fileSelectedSubject
      .pipe(
        switchMap((file: File) =>
          this.readFile(file).pipe(
            switchMap((fileContent) =>
              this.client.uploadLabels(fileContent).pipe(
                map((success) => {
                  this.showSuccessSnackbar();
                }),
                catchError((error) => {
                  this.anbModal.open<ExceptionDialogComponent, boolean>(ExceptionDialogComponent, {
                    data: { title: 'Fout', message: 'Fout opgetreden bij het uploaden van labels.' },
                  });
                  console.error('File upload failed', error);
                  return of(null);
                }),
              ),
            ),
          ),
        ),
      )
      .subscribe();
  }
  triggerFileInputClick(): void {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (file) {
      this.fileSelectedSubject.next(file);
    }
    event.target.value = '';
  }
  private readFile(file: File): Observable<string> {
    const fileReader = new FileReader();
    const fileReader$ = fromEvent(fileReader, 'load').pipe(map(() => fileReader.result as string));

    fileReader.readAsText(file);
    return fileReader$;
  }
  showSuccessSnackbar() {
    const alert = {
      title: this.translateService.instant('TOAST.SUCCESS_TITLE'),
      message: this.translateService.instant('UPLOAD.LABEL_SUCCESS'),
      type: AlertType.Success,
      canClose: true,
      closeAfterSeconds: 10,
    } as SnackBarAlert;
    this.snackbarService.showAlert(alert);
  }
}
